/* eslint-disable */
export default {
  unknown: '알 수 없음',
  multipleMatches: '여러 일치 항목',
  anonymous: '익명',
  none: '없음',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
